/**
 * Configuración y lista blanca de rutas con rediseño móvil migrado y aprobado.
 * 
 * Regla de Oro:
 * - En Fase 0 esta lista inicia VACÍA ([]), garantizando que ninguna pantalla
 *   cambie su apariencia ni comportamiento hasta que comience su migración.
 * - En Fase 1 se irá incorporando cada ruta al ser completada y aprobada:
 *   ['/', '/planning', '/quality', '/payments']
 */

export const MIGRATED_MOBILE_ROUTES: string[] = ['/', '/planning', '/quality', '/payments'];

/**
 * Determina si la ruta actual corresponde a una pantalla con rediseño móvil aprobado.
 */
export const isMigratedMobileRoute = (pathname: string): boolean => {
    return MIGRATED_MOBILE_ROUTES.some(r => pathname === r || pathname.startsWith(r + '/'));
};
